import {Component, inject, DestroyRef,effect} from '@angular/core';
import {InvoicesRequest} from "../../../core/invoices/api/invoices.request.model";
import {InvoicesService} from "../../../core/invoices/services/invoices.service";
import {FormBuilder, FormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import {Router} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {UserService} from "../../../core/user/services/user.service";
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatButtonModule} from "@angular/material/button";

@Component({
  selector: 'app-search-widget',
  templateUrl: './search-widget.component.html',
  styleUrl: './search-widget.component.scss',
  imports: [ReactiveFormsModule,
  MatFormFieldModule,
    MatInputModule,
    MatButtonModule]
})
export class SearchWidgetComponent {
  private destroyRef = inject(DestroyRef);
  public isAdmin = false;
  public idfs: any[] = [];
  public noIdf = true;
  public selectedIdf = '9999910';
  private userService: UserService = inject(UserService);
  private invoicesService: InvoicesService = inject(InvoicesService);
  private formBuilder = inject(FormBuilder);
  private router = inject(Router);

  quickSearch = this.formBuilder.group({
    docNr: ['', Validators.required],
    idf: ['', Validators.required]
  })

  quickPZNSearch = this.formBuilder.group({
    pzn: ['']
  })

  constructor() {

    this.userService.getUserLoadingObservable().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((load: any) => {
      if (!load) {
        this.isAdmin = this.userService.isAdmin();
      }
    });

    effect(() => {
      const idf = this.userService.selectedIdf();
      if (idf) {
        this.selectedIdf = idf;
        this.noIdf = false;
        this.quickSearch.patchValue({idf: idf});
      } else {
        this.noIdf = true;
      }
    });
  }

  doQuickSearch(stepper: any) {
    if (!this.quickSearch.valid) {
      return;
    }

    const values = this.quickSearch.value;
    const now = new Date();
    const endDate = now.toISOString().split('T')[0];
    const startDate = new Date(now.setFullYear(now.getFullYear() - 1)).toISOString().split('T')[0];
    const request = new InvoicesRequest({
      idf: this.userService.selectedIdf(),
      branch: 21,
      startDate: startDate,
      endDate: endDate,
      docType: "ALL",
      docNr: values.docNr
    });

    this.invoicesService.quickNrSearch.next(request);
    this.router.navigate(['/belege'])
  }

  doQuickPZNSearch(stepper: any) {
    console.log('pzn search')
  }
}
